/* Taunus Timepieces – Theme-Interaktionen */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var fine = matchMedia('(pointer:fine)').matches;

  /* Header */
  var nav = $('.tt-nav'), burger = $('.tt-burger'), menu = $('.tt-menu');
  function closeMenu() { if (!menu) return; menu.hidden = true; burger.setAttribute('aria-expanded', 'false'); document.body.classList.remove('tt-menu-open'); nav.classList.remove('menu-on'); }
  if (burger && menu) {
    burger.addEventListener('click', function () { var open = menu.hidden; menu.hidden = !open; burger.setAttribute('aria-expanded', open ? 'true' : 'false'); document.body.classList.toggle('tt-menu-open', open); nav.classList.toggle('menu-on', open); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) closeMenu(); });
  }
  var path = location.pathname.replace(/\/(en|de)(?=\/|$)/, '');
  $$('.tt-nav a[href], .tt-menu a[href]').forEach(function (a) {
    var h = a.getAttribute('href').replace(/\/(en|de)(?=\/|$)/, '').split('?')[0];
    if (h && h !== '/' && path.indexOf(h) === 0) a.classList.add('on');
  });

  /* Word split (hero) */
  function splitWords(el, d0, step) {
    if (!el || el.dataset.split) return; el.dataset.split = '1';
    var parts = [];
    el.childNodes.forEach(function (n) {
      if (n.nodeType === 3) { n.textContent.split(/\s+/).filter(Boolean).forEach(function (w) { parts.push({ w: w }); }); }
      else { parts.push({ w: n.textContent, cls: n.tagName === 'EM' ? 'tt-serif' : (n.className || '') }); }
    });
    el.innerHTML = parts.map(function (p, i) { return '<span class="tt-word"><span class="' + (p.cls || '') + '" style="animation-delay:' + (d0 + i * step).toFixed(2) + 's">' + esc(p.w) + '</span></span>'; }).join(' ');
  }
  splitWords($('[data-tt-headline]'), .25, .09);

  /* Statement */
  var st = $('[data-tt-statement]');
  if (st && !st.dataset.split) {
    st.dataset.split = '1'; var out = [];
    st.childNodes.forEach(function (n) {
      var gold = n.nodeType !== 3 && n.tagName === 'EM';
      (n.textContent || '').split(/\s+/).filter(Boolean).forEach(function (w) { out.push('<span class="w' + (gold ? ' gold' : '') + '">' + esc(w) + '</span>'); });
    });
    st.innerHTML = out.join(' ');
  }

  /* Marquee duplicate */
  $$('.tt-marquee').forEach(function (m) { if (!m.dataset.dup) { m.dataset.dup = '1'; m.innerHTML += m.innerHTML; } });

  /* 3D tilt */
  function initTilt(scope) {
    $$('.tt-t3d', scope).forEach(function (t) {
      if (t.dataset.tilt) return; t.dataset.tilt = '1';
      var inner = $('.inner', t); if (!inner) return;
      var g = document.createElement('div'); g.className = 'glare'; inner.appendChild(g);
      if (!fine) return;
      t.addEventListener('pointermove', function (e) {
        var r = inner.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        inner.style.setProperty('--gx', (px * 100).toFixed(1) + '%'); inner.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        t.dataset.hover = '1';
        inner.style.transform = 'rotateY(' + ((px - .5) * 14).toFixed(2) + 'deg) rotateX(' + ((.5 - py) * 12).toFixed(2) + 'deg) scale(1.025)';
        inner.style.boxShadow = '0 40px 90px rgba(40,36,18,.24)';
      });
      t.addEventListener('pointerleave', function () { t.dataset.hover = ''; inner.style.transform = ''; inner.style.boxShadow = ''; });
    });
  }

  /* Reveal + counters */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .12, rootMargin: '0px 0px -30px 0px' }) : null;
  function initReveal(scope) {
    $$('.tt-reveal:not(.in)', scope).forEach(function (el) {
      if (!io || el.getBoundingClientRect().top < innerHeight) { el.classList.add('in'); return; }
      io.observe(el);
    });
  }
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; cio.unobserve(e.target);
        var end = +e.target.dataset.count, t0 = performance.now(), dur = 1500;
        (function tk(t) { var k = Math.min((t - t0) / dur, 1); e.target.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tk); })(t0);
      });
    }, { threshold: .6 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  /* Scroll frame */
  var orbs = $$('.tt-orb').map(function (el, i) { return [el, [-.1, .07, -.05][i] || -.05]; });
  var tick = false;
  var scroller = document.querySelector('.page-wrapper');
  function getY() { return (scroller && scroller.scrollHeight > scroller.clientHeight + 10) ? scroller.scrollTop : scrollY; }
  function frame() {
    var y = getY(), vh = innerHeight;
    if (nav) nav.classList.toggle('scrolled', y > 36);
    orbs.forEach(function (o) { o[0].style.transform = 'translateY(' + (y * o[1]) + 'px)'; });
    $$('.tt-panel img').forEach(function (img) { var r = img.parentElement.getBoundingClientRect(); var c = (r.top + r.height / 2 - vh / 2) / vh; img.style.transform = 'scale(1.08) translateY(' + (c * 34).toFixed(1) + 'px)'; });
    $$('.tt-t3d').forEach(function (t) {
      if (t.dataset.hover === '1') return;
      var inner = $('.inner', t), r = t.getBoundingClientRect(); if (!inner) return;
      if (r.bottom < -80 || r.top > vh + 80) return;
      var c = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / (vh * .75)));
      inner.style.transform = 'rotateX(' + (c * 7).toFixed(2) + 'deg) translateZ(0)';
    });
    if (st) {
      var sr = st.getBoundingClientRect(), prog = Math.min(Math.max((vh * .82 - sr.top) / (sr.height + vh * .35), 0), 1), ws = $$('.w', st);
      ws.forEach(function (w, i) { w.classList.toggle('lit', i / ws.length < prog); });
    }
    tick = false;
  }
  document.addEventListener('scroll', function () { if (!tick) { requestAnimationFrame(frame); tick = true; } }, { passive: true, capture: true });
  frame();

  /* Product gallery */
  $$('.tt-gallery').forEach(function (g) {
    var main = $('.main img', g);
    $$('.tt-thumbs button', g).forEach(function (b) {
      b.addEventListener('click', function () {
        main.style.opacity = 0;
        setTimeout(function () { main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; main.alt = b.dataset.alt || ''; main.style.opacity = 1; }, 180);
        $$('.tt-thumbs button', g).forEach(function (x) { x.classList.toggle('on', x === b); });
      });
    });
  });

  /* Recommendations */
  $$('[data-tt-recommendations]').forEach(function (el) {
    var url = el.dataset.url; if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-tt-recommendations]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initTilt(el); initReveal(el); } else { el.closest('.tt-related') && (el.closest('.tt-related').hidden = true); }
    }).catch(function () {});
  });

  /* Ankauf: Sofort-Einschätzung */
  $$('[data-tt-estimate]').forEach(function (form) {
    var list = []; try { list = JSON.parse($('[data-tt-pricelist]', form).textContent || '[]'); } catch (e) {}
    var ref = $('[name="contact[Modell / Referenz]"]', form) || $('[name="contact[Referenz]"]', form), box = $('.tt-estimate', form);
    if (!ref || !box || !list.length) return;
    var fmt = function (n) { return Number(n).toLocaleString(document.documentElement.lang || 'de', { maximumFractionDigits: 0 }) + ' €'; };
    var tpl = box.dataset.template || '{ref}: {min} – {max}';
    ref.addEventListener('input', function () {
      var v = ref.value.toLowerCase().replace(/[^a-z0-9]/g, ''); var hit = null;
      if (v.length >= 5) list.forEach(function (row) { var k = String(row.ref || '').toLowerCase().replace(/[^a-z0-9]/g, ''); if (k && v.indexOf(k) >= 0) hit = row; });
      if (hit) { box.innerHTML = tpl.replace('{ref}', esc(hit.ref)).replace('{min}', '<b>' + fmt(hit.min) + '</b>').replace('{max}', '<b>' + fmt(hit.max) + '</b>'); box.classList.add('on'); }
      else box.classList.remove('on');
    });
  });

  /* Init */
  document.documentElement.classList.remove('no-js');
  initReveal(document); initTilt(document); frame();
  if (location.hash && $(location.hash)) { setTimeout(function () { var el = $(location.hash); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100); }
})();
